import React from 'react';
import { I18nextTrans, useTranslation } from '@common/hooks/useTranslation';
import { Button } from '@components/Button';
import { Text } from '@components/Text';
import { Benefit } from './Benefit';
import { maxAdBenefits } from './maxAdBenefits';

export type Props = {
  adDuration?: number;
  price: React.ReactNode;
  immediateStartText: string;
  onUpgradeButtonClicked?: () => void;
};

export const MaxAdInfoWithUpgradeButton = (props: Props) => {
  const {
    adDuration = '-',
    price,
    onUpgradeButtonClicked,
    immediateStartText
  } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="flex flex-col">
        <div className="flex flex-row justify-between">
          <Text size="xlarge" weight="regular" testID="max-package">
            {t('upgradeJob.maxPackage.name')}
          </Text>
          {price}
        </div>
        <Text size="small" weight="regular" tone="neutralLight">
          {t('upgradeJob.maxPackage.details', { adDuration })}
        </Text>
      </div>

      <div className="flex flex-col gap-sm mt-md">
        {maxAdBenefits.map((benefit, index) => (
          <div key={index} className="flex flex-col gap-1">
            <Text weight="regular" size="standard">
              <I18nextTrans
                i18nKey={benefit.title}
                components={[<Text size="standard" weight="bold" />]}
              />
            </Text>
            <div className="flex flex-col">
              {benefit.points.map((point, pointIndex) => (
                <Benefit key={pointIndex}>
                  {t(point, { immediateStartName: immediateStartText })}
                </Benefit>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col gap-sm mt-md">
        <Button fullWidth onPress={onUpgradeButtonClicked}>
          {t('enhanceJob.enhanceToMax')}
        </Button>
      </div>
    </div>
  );
};
